import classNames from "classnames";

import styles from "./ResponsiveContainer.module.scss";

type CONTAINER_SIZES = "small" | "medium" | "large";

type ResponsiveContainerProps = {
  fullWidth?: boolean;
  size?: CONTAINER_SIZES;
};

export const ResponsiveContainer = ({
  children,
  fullWidth = false,
  size,
}: React.PropsWithChildren<ResponsiveContainerProps>) => {
  const currentClassNames = classNames(styles.responsiveContainer, fullWidth && styles.fullWidth, size && styles[size]);

  return (
    <div data-testid={"responsiveContainer"} className={currentClassNames}>
      {children}
    </div>
  );
};
